import styled from 'styled-components';

export const ConfirmTransferModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 10px auto;
  flex: 1 0 auto;
  min-width: 250px;
`;
